import { useEffect } from 'react';
import styles from './index.module.css';
import VideoAlert from '../video-alert';
import { useRef } from 'react';
import DOMPurify from 'dompurify';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
const Header = ({ textData,language }) => {
  const ctnRef = useRef(null);
  const img1Ref = useRef(null);
  const img2Ref = useRef(null);
  const img3Ref = useRef(null);
  useEffect(() => {
    new VideoAlert({
      havePathElement: `.${styles.watchVideoButton}`,
    });
  }, []);

  useEffect(() => {
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: ctnRef.current,
        start: 'top top',
        end: '40%',
        scrub: 1.5,
        pin: true,
      },
    });

    tl.to(img1Ref.current, {
      y: -100,
    });

    tl.to(
      img2Ref.current,
      {
        y: -60,
      },
      0,
    );

    tl.to(
      img3Ref.current,
      {
        y: -30,
      },
      0,
    );
  }, []);
  return (
    <div className={styles.ctn} ref={ctnRef}>
      <img
        ref={img1Ref}
        src={`https://bucket.zhiyun-tech.com/detail/fiverayf100/f100-home-01-${language}.svg`}
        alt=""
      />
      <img
        ref={img2Ref}
        src="https://bucket.zhiyun-tech.com/detail/fiverayf100/f100-home-02.png"
        alt=""
      />
      <img
        ref={img3Ref}
        src="https://bucket.zhiyun-tech.com/detail/fiverayf100/f100-home-03.png"
        alt=""
      />

      <div
        className={styles.watchVideoButton}
        data-video-src={`https://bucket.zhiyun-tech.com/detail/fiverayf100/f100-tvc-${language === 'cn' ? 'cn' : 'en'}.mp4`}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.55554 15.7536V4.24625C5.55554 3.36948 6.52349 2.83813 7.26318 3.30885L16.3047 9.06254C16.9908 9.49916 16.9908 10.5007 16.3047 10.9373L7.26318 16.691C6.52349 17.1618 5.55554 16.6304 5.55554 15.7536Z"
            fill="url(#paint0_linear_405_2179)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_405_2179"
              x1="5.99988"
              y1="16"
              x2="15.9999"
              y2="8.5"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#FFCC66" />
              <stop offset="0.515625" stop-color="#FF6666" />
              <stop offset="1" stop-color="#9966FF" />
            </linearGradient>
          </defs>
        </svg>

        <div
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData['text2']),
          }}
        ></div>
      </div>
    </div>
  );
};

export default Header;
